;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import * as React from "react";

function throttle(cb: () => void, ms: number) {
	let lastTime = 0;
	return () => {
		const now = Date.now();
		if (now - lastTime >= ms) {
			cb();
			lastTime = now;
		}
	};
}

export function useIdle(ms = 1000 * 60) {
	const [idle, setIdle] = React.useState(false);

	React.useEffect(() => {
		let timeoutId: number;

		const handleTimeout = () => {
			setIdle(true);
		};

		const handleEvent = throttle(() => {
			setIdle(false);
			window.clearTimeout(timeoutId);
			timeoutId = window.setTimeout(handleTimeout, ms);
		}, 500);

		const handleVisibilityChange = () => {
			if (!document.hidden) {
				handleEvent();
			}
		};

		timeoutId = window.setTimeout(handleTimeout, ms);

		// Desktop events
		window.addEventListener("mousemove", handleEvent);
		window.addEventListener("mousedown", handleEvent);
		window.addEventListener("keydown", handleEvent);
		window.addEventListener("resize", handleEvent);

		// Mobile events - use passive for better performance
		window.addEventListener("touchstart", handleEvent, { passive: true });
		window.addEventListener("touchmove", handleEvent, { passive: true });
		window.addEventListener("scroll", handleEvent, { passive: true });

		// Visibility
		document.addEventListener("visibilitychange", handleVisibilityChange);

		return () => {
			window.removeEventListener("mousemove", handleEvent);
			window.removeEventListener("mousedown", handleEvent);
			window.removeEventListener("keydown", handleEvent);
			window.removeEventListener("resize", handleEvent);
			window.removeEventListener("touchstart", handleEvent);
			window.removeEventListener("touchmove", handleEvent);
			window.removeEventListener("scroll", handleEvent);
			document.removeEventListener("visibilitychange", handleVisibilityChange);
			window.clearTimeout(timeoutId);
		};
	}, [ms]);

	return idle;
}
